import { EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Descriptions,
	Form,
	Switch,
	Tooltip,
	theme,
} from "antd";
import { useEffect, useState } from "react";
import type { CategoryMessageDetail } from "../../types";
import { EventMessageModal } from "./EventMessageModal";

export const CategoryEventMessage = ({
	defaultOpen = false,
}: {
	defaultOpen?: boolean;
}) => {
	const { token } = theme.useToken();
	const colorPrimary = token.colorPrimary;
	const form = Form.useFormInstance();

	const [isMessage, setIsMessage] = useState(defaultOpen);
	const [categoryMessageDetail, setCategoryMessageDetail] =
		useState<CategoryMessageDetail>({});
	const [isEventMessageModalVisible, setIsEventMessageModalVisible] =
		useState(false);

	const isMessageValue = Form.useWatch("isMessage", form);
	const categoryMessageDetailValue = Form.useWatch(
		"categoryMessageDetail",
		form,
	);

	useEffect(() => {
		if (isMessageValue !== undefined) {
			setIsMessage(isMessageValue);
		}
		if (categoryMessageDetailValue) {
			let details = categoryMessageDetailValue;
			if (typeof details === "string") {
				try {
					details = JSON.parse(details);
				} catch (_e) {
					details = {};
				}
			}
			setCategoryMessageDetail(details);
		}
	}, [isMessageValue, categoryMessageDetailValue]);

	const hideEventMessageModal = () => {
		setIsEventMessageModalVisible(false);
	};

	const showEventMessageModal = () => {
		setIsEventMessageModalVisible(true);
	};

	const onSubmitEventMessageModal = (value: CategoryMessageDetail) => {
		form.setFieldValue("categoryMessageDetail", value);
		setCategoryMessageDetail(value);
	};

	return (
		<>
			<div className="flex gap-x-4 h-8 items-center mb-4">
				<div className="flex gap-x-2 items-center">
					<span>事前通知メッセージ</span>

					<Tooltip
						title={
							<div>
								<div>OFFの場合は[設定]ページの登録内容が踏襲されます。</div>
							</div>
						}
						overlayInnerStyle={{ width: 300 }}
					>
						<QuestionCircleOutlined
							style={{
								color: colorPrimary,
								marginRight: 12,
							}}
						/>
					</Tooltip>

					<Form.Item noStyle name="isMessage" valuePropName="checked">
						<Switch
							onChange={(val) => {
								form.setFieldValue("isMessage", val);
								setIsMessage(val);
							}}
						/>
					</Form.Item>

					<Form.Item noStyle name="categoryMessageDetail" hidden></Form.Item>
				</div>
			</div>

			{isMessage && (
				<Col xs={24} className="mb-6">
					<Card
						title="通知設定"
						bordered={true}
						type="inner"
						className="border-gray-300"
						headStyle={{ backgroundColor: "#f5f5f5" }}
					>
						<Card
							title="お客様通知"
							type="inner"
							extra={
								<div className="flex">
									<Button
										size="large"
										icon={<EditOutlined />}
										onClick={showEventMessageModal}
									>
										編集
									</Button>
								</div>
							}
						>
							<Descriptions column={1} bordered layout="vertical">
								<Descriptions.Item label="予約後に配信されるメッセージ">
									<p className="whitespace-pre-wrap">
										{categoryMessageDetail?.afterReservationMessage || "ー"}
									</p>
								</Descriptions.Item>
								<Descriptions.Item label="リマインドメッセージ（予約より7日前に配信される）">
									<p className="whitespace-pre-wrap">
										{categoryMessageDetail?.reminderMessageSevenDays || "ー"}
									</p>
								</Descriptions.Item>
								<Descriptions.Item label="リマインドメッセージ（予約より1日前に配信される）">
									<p className="whitespace-pre-wrap">
										{categoryMessageDetail?.reminderMessageOneDay || "ー"}
									</p>
								</Descriptions.Item>
							</Descriptions>
						</Card>
					</Card>
				</Col>
			)}

			<EventMessageModal
				isEventMessageModalVisible={isEventMessageModalVisible}
				hideEventMessageModal={hideEventMessageModal}
				currentCategoryMessageDetail={categoryMessageDetail}
				onSubmit={onSubmitEventMessageModal}
			/>
		</>
	);
};
